import { DEPRECIATION_METHOD_CODE } from 'common/constants'

export const getDefaultServiceLife = (depreciationCode?: number | string) => {
  switch (depreciationCode) {
    case DEPRECIATION_METHOD_CODE.AVERAGE_USAGE_PERIOD:
    case DEPRECIATION_METHOD_CODE.LEASE_PERIOD_STRAIGHT_LINE:
    case DEPRECIATION_METHOD_CODE.NON_DEPRECIATION:
    case DEPRECIATION_METHOD_CODE.NON_DEPRECIABLE:
      return undefined
    case DEPRECIATION_METHOD_CODE.DEFERRED_EQUAL_INSTALLMENT:
      return 1
    case DEPRECIATION_METHOD_CODE.BULK_EQUAL_INSTALLMENT_METHOD:
      return 3
    case DEPRECIATION_METHOD_CODE.SMALL_AMOUNT_DEPRECIABLE_ASSET:
      return 0
    default:
      return 2
  }
}
